import { render, staticRenderFns } from "./campaign-phone-numbers.vue?vue&type=template&id=1788c5b8&scoped=true&"
import script from "./campaign-phone-numbers.vue?vue&type=script&lang=js&"
export * from "./campaign-phone-numbers.vue?vue&type=script&lang=js&"
import style0 from "./campaign-phone-numbers.vue?vue&type=style&index=0&id=1788c5b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1788c5b8",
  null
  
)

export default component.exports